import Page from '../components/core/Page.vue'

export default function (manifest) {
    let pages = [];
    let custom = [];

    let tempmanifest = {
        pages: [],
        custom: []
    }
    tempmanifest.pages = manifest.root.children
    custom = manifest.root.children.find(data => data.type === "customDataForDigitalTool").children

    //flattenPages(root, null, '')
    tempmanifest.pages.forEach(page => flattenPages(page, null, ''))

    return {
        pages,
        custom
    }


    function flattenPages(node, parent, route) {
        route = route + '/' + sanitizeSlug(node.name);

        let page = formatPage(node, parent, route)

        //digital tool specific catch for custom data 
        if (!page.route.includes('/custom-data'))
            pages.push(page)


        if (node.children) {
            node.children.forEach(c => flattenPages(c, node, route))
        }
    }

    function formatPage(node, parent, route) {
        // format Page for usable data from json manifest provided by Umbraco
        return {
            id: node.id,
            component: Page,
            title: node.name,
            slug: sanitizeSlug(node.name),
            route,
            parent: parent ? sanitizeSlug(parent.name) : null,
            data: node.data,
            components: node.components ? node.components.map(c => {
                return {
                    id: c.id,
                    type: c.type,
                    properties: {
                        ...c
                    }
                }
            }) : []
        }
    }

    // Sanitize slugs for a clean url
    function sanitizeSlug(slug = '') {
        var s = slug
            .toLowerCase()
            .replace(/[^\w ]+/g, '')
            .replace(/ +/g, '-')

        return encodeURI(s).replace('%E2%80%93', '-')
    }
}